import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import GenericPage from '../../components/GenericPage';
import {
    fetchReporttailorworks,
    createReporttailorwork,
    updateReporttailorwork,
    deleteReporttailorwork,
    downloadReporttailorwork,
    setPagination,
    setSort,
    searchReporttailorworks,
    setDefaultFilter,
    changeCondition,
    addNewCondition,
    updateOptionRule,
    updateOptionValue,
    removeCondition,
    saveFilterCondition,
    setSelected,
    resetFiltersAndPagination,

    changeClassicFilter
} from '../../store/modules/reporttailorwork/reporttailorworkActions';
import ReporttailorworkForm from '../../components/pageModule/Reporttailorworks/ReporttailorworkForm';

const MySwal = withReactContent(Swal);

const Reporttailorworks = ({
    excludedActions = [],
    onSelectedRowsChange = () => { },
    onClickedRow = () => { },
    externalCondition = {},
    selectedIds = []
}) => {

    const reporttailorworkState = useSelector(state => state.reporttailorwork);
    const dispatch = useDispatch();

    useEffect(() => {
        return () => {
            dispatch(resetFiltersAndPagination());
        };
    }, []);

    const handleCreate = async (formData) => {
        try {
            const response = await dispatch(createReporttailorwork(formData));
            toast.success('Reporttailorwork created successfully', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
            return response;
        } catch (error) {
            toast.error(error.message || 'Error creating reporttailorwork', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
            throw error;
        }
    };

    const handleUpdate = async (id, formData) => {
        try {
            const response = await dispatch(updateReporttailorwork(id, formData));
            toast.success('Reporttailorwork updated successfully', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
            return response;
        } catch (error) {
            toast.error(error.message || 'Error updating reporttailorwork', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
            throw error;
        }
    };

    const handleDelete = async (id) => {
        const result = await MySwal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
            reverseButtons: true
        });

        if (result.isConfirmed) {
            try {
                await dispatch(deleteReporttailorwork(id));
                toast.success('Reporttailorwork deleted successfully', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
                return true;
            } catch (error) {
                toast.error(error.message || 'Error deleting reporttailorwork', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
                return false;
            }
        }
        return false;
    };

    const handleDownload = async (type) => {
        try {
            const response = await dispatch(downloadReporttailorwork(type));
            window.open(response.url, '_blank')
            return response;
        } catch (error) {
            toast.error(error.message || 'Error downloading reporttailorworks', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        }
    };

    const columns = [
        {
            name: 'Tailor ID',
            selector: row => row.tailor_code ?? '-'
        },
        {
            name: 'Name',
            selector: row => row.tailor_name ?? '-'
        },
        {
            name: 'Pieces',
            selector: row => row.total_pieces ?? '-'
        },
        {
            name: 'Charges',
            selector: row => row.total_price ?? '-',
        }
    ];


    const actions = {
        fetch: (queryFilter, activeFilter, shouldUseFilter, externalCondition) => dispatch(fetchReporttailorworks(queryFilter, activeFilter, shouldUseFilter, externalCondition)),
        create: handleCreate,
        update: handleUpdate,
        delete: handleDelete,
        download: handleDownload,
        search: (search) => dispatch(searchReporttailorworks(search)),
        setPagination: (pagination) => dispatch(setPagination(pagination)),
        setSort: (sort) => dispatch(setSort(sort)),
        setDefaultFilter: (filter) => dispatch(setDefaultFilter(filter)),
        changeCondition: (index, condition) => dispatch(changeCondition(index, condition)),
        addNewCondition: (rule) => dispatch(addNewCondition(rule)),
        updateOptionRule: (index, rule) => dispatch(updateOptionRule(index, rule)),
        updateOptionValue: (index, value) => dispatch(updateOptionValue(index, value)),
        removeCondition: (index) => dispatch(removeCondition(index)),
        saveFilterCondition: (filter) => dispatch(saveFilterCondition(filter)),
        setSelected: (selectedRows) => dispatch(setSelected(selectedRows)),

        onClassicFilterChange: (name, value) => dispatch(changeClassicFilter(name, value)),
    };

    const defaultAvailableActions = ['export_pdf', 'export_excel'];
    const availableActions = defaultAvailableActions.filter(action => !excludedActions.includes(action));

    return (
        <>
            <GenericPage
                title="Report Tailor wise Piece Work Cards"
                moduleName="Reporttailorwork"
                moduleKey="reporttailorworks"
                state={reporttailorworkState}
                actions={actions}
                FormComponent={ReporttailorworkForm}
                columns={columns}
                availableActions={availableActions}
                actionsColumnWidth="150px"
                selectableRows={false}
                onSelectedRowsChange={onSelectedRowsChange}
                onClickedRow={onClickedRow}
                selectedIds={selectedIds}
                externalCondition={externalCondition}
            />
        </>
    );
};

export default Reporttailorworks; 